import { useEffect } from 'react';
import { useRequester } from '../../../../hooks';
import { CompanyResource, type CompanyData } from '../../../../resources';

export function useCompanyList() {
  const fetch = useRequester<CompanyResource[]>({
    onSubmit: () => CompanyResource.fetchMany(),
    onError: console.log,
  });

  useEffect(() => {
    if (fetch.loading) return;
    fetch.submit();
  }, []);

  return {
    items: CompanyResource.list().map((d) => d.data) as CompanyData[],
    count: CompanyResource.list().length,
    isLoading: fetch.loading,
    hasError: !!fetch.error,
    error: fetch.error,
    refetch: fetch.submit,
  };
}
